import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Modal, Alert } from 'antd'
import { IUserResponse } from '@getgreenline/homi-shared'

interface Props {
  visible: boolean
  selectedEmployee: IUserResponse
  removeEmployee: VoidFunction
  onCancel: VoidFunction
  isOwnEmployeeAccount: boolean
}

@observer
export class EmployeeDeleteModal extends Component<Props> {
  render() {
    const { visible, removeEmployee, onCancel, selectedEmployee, isOwnEmployeeAccount } = this.props

    return (
      <Modal
        title={`Remove ${selectedEmployee.name}`}
        visible={visible}
        okText='Remove'
        okType='danger'
        onOk={removeEmployee}
        onCancel={() => onCancel()}
        maskClosable={false}
        okButtonProps={{
          disabled: isOwnEmployeeAccount,
        }}
      >
        {isOwnEmployeeAccount ? (
          <Alert type='error' message={`You cannot delete your own account.`} />
        ) : (
          <>
            The data (sales, inventory) from this employee will still exist on the system, but you
            won't be able to filter by the employee anymore.
            <p />
            If you still want to be able to search/filter this data, we suggest assigning the user
            to a limited security role, removing the email, and removing the passcode.
          </>
        )}
      </Modal>
    )
  }
}
